module.exports = __webpack_public_path__ + "img/r1.23753a23.jpg";